import getCookieValue from '@utils/cookies';
import { AwsRumConfig } from 'aws-rum-web';
import { includes } from 'lodash';
import { RumParams } from 'types/RUM.types';

import { version } from '../../../package.json';

// Disable or enable development as needed here (i.e. ['development', 'production']
// Will need a modified dev-auriga-config file for localhost as well
export const RUM_ENABLED_ENVIRONMENTS = ['production'];

/**
 * Auriga Extended RUM Configuration interface that includes cookie values received from expected RumParams cookie
 */
export interface AurigaRumConfig {
  applicationId: string;
  applicationVersion: string;
  applicationRegion: string;
  rumConfig: AwsRumConfig;
}

/**
 * Generate CloudWatch RUM Config for Auriga's RUM Metrics Logger
 */
export const generateRumConfig = (): AurigaRumConfig | null => {
  // Generate RUM Config for enabled environments
  if (includes(RUM_ENABLED_ENVIRONMENTS, process.env.NODE_ENV)) {
    const rumCookieValue = getCookieValue('RumParams');

    if (!rumCookieValue) {
      throw new Error('RumParams cookie not found. Make sure the RUM config cookie is being set correctly');
    }

    try {
      // Parse the rum cookie value and apply it to the initialization config
      const parsedRumValues: RumParams = JSON.parse(rumCookieValue);
      const applicationId = parsedRumValues.rumAppMonitorId;
      const applicationVersion = version; // From package.json
      const applicationRegion = parsedRumValues.region;

      // Additional expected configuration parameters
      const rumConfig: AurigaRumConfig = {
        applicationId,
        applicationVersion,
        applicationRegion,
        rumConfig: {
          allowCookies: true,
          enableXRay: true,
          endpoint: `https://dataplane.rum.${parsedRumValues.region}.amazonaws.com`,
          identityPoolId: parsedRumValues.identityPoolId,
          sessionSampleRate: parsedRumValues.stageSampleRate,
          sessionEventLimit: 0, // 0 = no limit. We already reduce events by sessionSampleRate per deployment stage.
          signing: true,
          telemetries: parsedRumValues.telemetries,
        },
      };

      console.debug('RUM config generated', rumConfig);
      return rumConfig;
    } catch (rumConfigError) {
      console.error('RUM configuration error', rumConfigError);
      return null;
    }
  }
  return null;
};
